/** A persisted cloze is an inline span; reveal state belongs to the reader only. */
export const CLOZE_ID = /^[a-zA-Z0-9][a-zA-Z0-9_:-]{0,79}$/
export function validClozeId(value: string | null): value is string { return !!value && CLOZE_ID.test(value) }
